//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import _ from 'underscore'
// import DIC from '@/index/dictonary'

export default {
  props: {

  },
  data: function () {
    let tab = this.$route.query.tab || 'onSaleGoods'
    let r = {
      currentTab: tab,
      // currentTab: 'goods'
      searchData: {
        onSaleGoods: {},
        goods: {}
      },
      pageData: {
        onSaleGoods: {},
        goods: {}
      }
    }
    let searchData = {}
    let pageData = {}
    if (this.$route.query.searchData) {
      searchData = JSON.parse(this.$route.query.searchData)
    }
    if (this.$route.query.pageData) {
      pageData = JSON.parse(this.$route.query.pageData)
    }
    if (r.searchData[tab]) {
      r.searchData[tab] = searchData
    }
    if (r.pageData[tab]) {
      r.pageData[tab] = pageData
    }
    return r
  },
  components: {
    PageOnSaleGoods: () => import('./components/PageOnSaleGoods/index.vue'),
    PageAllGoods: () => import('./components/PageAllGoods/index.vue'),
    PageDealer: () => import('./components/PageDealer/index.vue'),
    PageBrand: () => import('./components/PageBrand/index.vue'),
    PageCategory: () => import('./components/PageCategory/index.vue')
  },
  mounted () {
    let p1 = new Promise((resolve, reject) => {
      this.$axios.get('/mtea/store/admin/goods/category/list', { params: {} }).then(res => {
        this.categoryOptions = res
      }).finally(() => {
        resolve()
      })
    })
    let p2 = new Promise((resolve, reject) => {
      this.$axios.get('/mtea/store/admin/goods/brand/list', { params: {} }).then(res => {
        this.brandOptions = res
      }).finally(() => {
        resolve()
      })
    })
    Promise.all([p1, p2]).then(() => {
    })
  },
  methods: {

  }
}
